(function () {
	var App = angular.module('pphhApp');
	
	App.service("uploadActionController", ["$mdDialog", UploadActionController]);
	
	function UploadActionController($mdDialog) {
		this.performAction = performAction;
		
		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body),
				locals: {
					cicloId: scope.cicloId
				},
				controller: scope.waterModule.key + "UploadDialogController",
				templateUrl: _contextPath + "/pphhNav/uploadDialog-init"
			}).then(function (res) {
			});
		}
	}
	
	function UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId) {
		var self = this;

		$scope.rbds = [];
		$scope.filter = {};
		$scope.closeButton = true;
		
		$scope.init = init;
		$scope.closeDialog = closeDialog;
		$scope.uploadFile = uploadFile;

		/**
		 * Callback que se invoca cuando la operación de carga se ha realizado
		 * correctamente.
		 */
		this.uploadFileSuccessCallback = function (response) {
			$scope.isLoading = false;
			var errorMessages = response.data.errorMessages;
			var field = errorMessages[0];
			$scope.message = field.message;
			$scope.closeButton = false;
		};


		/**
		 * Callback que se invoca cuando se ha producido algún error durante la
		 * operación de carga.
		 */
		this.uploadFileErrorCallback = function (response) {
			$scope.isLoading = false;
			var errorMessages = response.data.errorMessages;
			var field = errorMessages[0];
			$scope.message = field.message;
		};

		function init() {
			$http.get(_contextPath + "/pphhNav/import/dhList")
			.then(
					function (response) {
						$scope.rbds = response.data;
						if ($scope.rbds.length >= 1 && $scope.rbds.length <= 24) {
							$scope.filter.rbd = $scope.rbds[0].id;
						}
					});
		}

		function closeDialog() {
			$mdDialog.hide();
	    }

		function uploadFile() {
			$scope.isLoading = true;
			$scope.message ="";

			var rbd = -1;
			if (this.filter.rbd != null) {
				rbd =  this.filter.rbd;
			}
			uploadService.uploadFile(
					{
						file: $scope.file,
						rbdId: rbd
					}
			).then(self.uploadFileSuccessCallback, self.uploadFileErrorCallback);
		}
	}
	
	function DmaUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId) {

		$scope.statusSheet = false;
		/**
		 * Sólo se requiere la carga de la información de los background documents.
		 */
		$scope.onlyReferences = false;
		$scope.onlyGis = false;

		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);

		$scope.$watch("statusSheet", function (newVal, oldVal) {
			if(newVal === true) {
				$scope.onlyReferences = false;
				$scope.onlyGis = false;
				$scope.disabledRbd = false;	
			}
		});
		
		$scope.$watch("onlyReferences", function (newVal, oldVal) {
			if(oldVal !== newVal && newVal === true) {
				$scope.filter.rbd = -1;
				$scope.disabledRbd = true;
				$scope.statusSheet = false;
				$scope.onlyGis = false;
			} 
		});

		$scope.$watch("onlyGis", function (newVal, oldVal) {
			if(oldVal !== newVal && newVal === true) {
				$scope.filter.rbd = -1;
				$scope.disabledRbd = true;
				$scope.statusSheet = false;
				$scope.onlyReferences = false;
			}
		});

		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";
			uploadService.uploadFile(
					{
						file: $scope.file,
						rbdId: $scope.filter.rbd,
						importOptions: {
							onlyReferences: $scope.onlyReferences,
							statusSheet: $scope.statusSheet,
							onlyGis: $scope.onlyGis
						}
					}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}

	function WbmUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId) {

		$scope.onlyMasaCompartida = false;

		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);

		$scope.$watch("onlyMasaCompartida", function (newVal, oldVal) {
			if(oldVal !== newVal && newVal === true) {
				$scope.filter.rbd = -1;
				$scope.disabledRbd = true;
			} 
		});


		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";
			uploadService.uploadFile(
					{
						file: $scope.file,
						rbdId: $scope.filter.rbd,
						importOptions: {
							onlyMasaCompartida: $scope.onlyMasaCompartida
						}
					}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}

	function PomUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId) {

		/**
		 * Sólo se requiere la carga de la información de los background documents.
		 */
		$scope.onlyReferences = false;
		$scope.disabledRbd = false;
		
		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);

		$scope.$watch("onlyReferences", function (newVal, oldVal) {
			if(oldVal !== newVal && newVal === true) {
				$scope.filter.rbd = -1;
				$scope.disabledRbd = true;
			} else if(oldVal !== newVal && newVal === false) {
				$scope.disabledRbd = false;
			}
		});

		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";
			uploadService.uploadFile(
					{
						file: $scope.file,
						rbdId: $scope.filter.rbd,
						importOptions: {
							onlyReferences: $scope.onlyReferences
						}
					}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}

	function OigUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId) {

		$scope.onlyReferences = false;

		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);

		$scope.filter.rbd = -1;

		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";
			uploadService.uploadFile({
				file: $scope.file,
				rbdId: $scope.filter.rbd,
				}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}	
	
	function UwwUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId){
		
		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);
		$scope.filter.rbd = -1;
		$scope.filter.ccaa= null;
		
		$scope.init = function(){
			$http.get(_contextPath + "/pphhNav/export/auxCcaaList")
			.then(
					function (response) {
						$scope.auxCcaa = response.data;
						if ($scope.auxCcaa.length === 1 ) {
							$scope.filter.ccaa = $scope.auxCcaa[0];
						}
					});
		}
		
		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";

			uploadService.uploadFile({
				file: $scope.file,
				rbdId: $scope.filter.rbd,
				importOptions: {
					codeCcaa : $scope.filter.ccaa.codCcaa
				}
				}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}

	function AgeUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId){

		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);
		$scope.filter.rbd = -1;
		$scope.filter.admcomp= null;

		$scope.init = function(){
			$http.get(_contextPath + "/pphhNav/export/auxAdmonList")
				.then(
					function (response) {
						$scope.auxAdmonList = response.data;
						if ($scope.auxAdmonList.length === 1 ) {
							$scope.filter.admcomp = $scope.auxAdmonList[0];
						}
					});
		}

		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";

			uploadService.uploadFile({
					file: $scope.file,
					rbdId: $scope.filter.rbd,
					importOptions: {
						codeAdmon : $scope.filter.admcomp.idUdOrganica
					}
				}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}

	function ZpUploadDialogController($scope, $mdDialog, $http, uploadService, cicloId) {

		$scope.onlyReferences = false;

		var delegate = new UploadDialogControllerBase($scope, $mdDialog, $http, uploadService, cicloId);

		$scope.filter.rbd = -1;

		// @Override
		$scope.uploadFile = function() {
			$scope.isLoading = true;
			$scope.message = "";
			uploadService.uploadFile({
				file: $scope.file,
				rbdId: $scope.filter.rbd,
				}
			).then(delegate.uploadFileSuccessCallback, delegate.uploadFileErrorCallback);
		};
	}
	
	App.controller("dmaUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", DmaUploadDialogController]);
	App.controller("pdmUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);
	App.controller("pomUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", PomUploadDialogController]);
	App.controller("wbmUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", WbmUploadDialogController]);
	App.controller("acUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);
	App.controller("oigUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", OigUploadDialogController]);
	App.controller("pinfUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);	
	App.controller("piUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", DmaUploadDialogController]);
	App.controller("uwwUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UwwUploadDialogController]);
	App.controller("aruUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UwwUploadDialogController]);
	App.controller("nidUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);		
	App.controller("zpUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", ZpUploadDialogController]);
	App.controller("ecoUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);
	App.controller("omaUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase]);
    App.controller("ageUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
        "cicloId", AgeUploadDialogController]);
	App.controller("qecoUploadDialogController", ["$scope", "$mdDialog", "$http", "uploadService",
		"cicloId", UploadDialogControllerBase])
})();